import G from './Global';
import TafHandler from './TafHandler';
import ConstEnum  from './ConstEnum';
import logger from './utils/Logger';
import TafMx from './taf/tafMapping';
import store from './utils/store';
import EVENTS from './utils/SignalEvent';
import Report from './utils/Report';
import Taf from './taf/libwup';
import HUYA from './taf/TafProtocol';

class SignalSdk {
    constructor(cfg) {
        let config = {...cfg} || {};
    	logger.log("初始化",config);
        config.guid = config.guid || store.getCookie("guid");

        this.config = config;
        G.setEnableTrace(config);
        this.report = new Report(config);
        this.tafHandlerList = [];
        this.tafHandler = new TafHandler(config,this);
        if(!config.noConnect){
            this.tafHandler.start();
        }
        this.tafHandlerList.push(this.tafHandler);
        this.wsLaunch = false;
        this.queue = [];
        this.on(EVENTS.WEBSOCKET_DOLAUNCH, () => {
            logger.log('sendWup 缓存队列')
            this.wsLaunch = true;
            this.queue.forEach( fn => fn());
            this.queue = [];
        })
        this.inited = true;  
    }

    /**
     * 合并 wup 调用及解包绑定操作，简化调用。
     * @param {Object}  初始化参数 
     */
    bindWup(servantName) {
        return ({funcName, resStruct}) => {
            this.registerWup(funcName, resStruct);
            return ({data, callback, iRequestId}) => {
                this.sendWup(servantName, funcName, data, callback, iRequestId);
            }
        }
    }

    /*
     * 向服务器发送wup数据
     * servantName 可理解为服务器模块名（向服务器同学获取此信息）
     * funcName 可理解为服务器指定模块下的函数名（向服务器同学获取此信息）
     * data 协议数据（非简单Object，向服务器同学获取协议结构）
     * callback 数据返回时的回调函数，附带一个数据参数，用on监听时可省略此参数
     * tryCount 请求重试次数 默认1
     * extData  {wupTimeout}  wup服务超时时间
     */
    sendWup(servantName, funcName, data, callback,tryCount=1,extData={}) {
        let requestId  = G.getRequestId();
        const traceid = G.getTraceId(); //当做requetid使用
        this.report.setDim(requestId,"traceid",traceid);
        this.report.setDim(requestId,"spanid",traceid);
        this.report.setField(requestId,"execute");
        var re = {id:requestId,fn:funcName,cb:callback};
        if(!this.inited){
            re.code = ConstEnum.SIGNAL_ERROR_NO_INIT;
            this.tafHandler.reportError(re);
            return;
        }
        try{
            if(this.tafHandler.connected){
                logger.log('sendWup', funcName);
                this.tafHandler.sendWup(servantName, funcName, data, callback, requestId,tryCount,extData);
            }else{
                logger.log('sendWupHttp', funcName);
                this.tafHandler.sendWupHttp(servantName,funcName,data,requestId,callback,extData);
            }
            // else {
            //      logger.log('sendWup 添加到队列', funcName);
            //      this.queue.push(() => this.tafHandler.sendWup(servantName, funcName, data, callback, requestId,tryCount));
            // }
        }catch(err){
            re.code = ConstEnum.SIGNAL_ERROR_LOCAL_ERROR;
            this.tafHandler.reportError(re);
        }

    }

    sendWupNew(servantName,funcName,data,rsp,tryCount=1,extData={}){
        return this.tafHandler.sendWupNew(servantName,funcName,data,rsp,tryCount,extData);
    }

     /*
     * 向服务器发送wup数据 http请求
     * servantName 可理解为服务器模块名（向服务器同学获取此信息）
     * funcName 可理解为服务器指定模块下的函数名（向服务器同学获取此信息）
     * data 协议数据（非简单Object，向服务器同学获取协议结构）
     * callback 数据返回时的回调函数，附带一个数据参数，用on监听时可省略此参数
     * 
     */
    sendWupHttp(servantName, funcName, data,callback){
        let requestId = G.getRequestId();
        const traceid = G.getTraceId();
        this.report.setDim(requestId,"traceid",traceid);
        this.report.setDim(requestId,"spanid",traceid);
        this.report.setField(requestId,"execute");
        var re = {id:requestId,fn:funcName,cb:callback};
        if(!this.inited){
            re.code = ConstEnum.SIGNAL_ERROR_NO_INIT;
            this.tafHandler.reportError(re);
            return;
        }
        this.tafHandler.sendWupHttp(servantName,funcName,data,G.iRequestId,callback);
    }

      /*
     * 注册一个广播消息对应的数据结构，用于解码
     */
    registerUri(uri, ClassType) {
        TafMx.UriMapping[uri + ''] = ClassType;
    }

    /*
     * 注册多个广播消息对应的数据结构
     */
    registerUriMap(uriMap) {
        for (let uri in uriMap) {
            let ClassType = uriMap[uri];
            TafMx.UriMapping[uri + ''] = ClassType;
        }
    }

    /*
     * 注册一个WUP协议对应的数据结构，用于解码
     */
    registerWup(funcName, ClassType) {
        TafMx.WupMapping[funcName] = ClassType;
    }

    /*
     * 注册多个WUP协议对应的数据结构
     */
    registerWupMap(wupMap) {
        for (let funcName in wupMap) {
            let ClassType = wupMap[funcName];
            TafMx.WupMapping[funcName] = ClassType;
        }
    }

    /*
     * 监听服务器消息
     */
    on(type, callback) {
        this.tafHandlerList.forEach( tafHandler => {
            tafHandler.on(type,callback);
        });
    }

    /*
     * 移除服务器消息监听
     */
    off(type, callback) {
        this.tafHandlerList.forEach(tafHandler =>{
            if (tafHandler.hasOwnProperty('removeListener')) {
                tafHandler.removeListener(type,callback);
            } else if (tafHandler.hasOwnProperty('off')) {
                tafHandler.off(type,callback);
            } 
        });
    }

    /*
     * 返回是否已监听指定消息
     */
    has(type) {
        return  this.tafHandler.listenerCount(type)  > 0;
    }

     /*
     * 加入用户组
     * groupList 组列表
     */
    sendRegisterGroup(groupList, sToken = '') {
        this.tafHandler.sendRegisterGroup(groupList, sToken);
    }

    /*
     * 退出用户组
     * groupList 组列表
     */
    sendUnRegisterGroup(groupList) {
        this.tafHandler.sendUnRegisterGroup(groupList);
    }

    /*
     * web端登录需要校验cookie
     */
    sendVerifyCookie(uid, guid, UA = 'webh5&0.0.1&huya') {
        this.tafHandler.sendVerifyCookie(uid, guid, UA);
    }


    /*
     * 重新建立websocket连接
     */
    reconnetWS(type=0){
        const tafHandler = this.tafHandlerList.find(taf => taf.connectType === type);
        if(tafHandler){
            return tafHandler.reconnetWS();
        }
    }
    
    /*
     * ws是否连接上了
     */
    isWSConnected(type=0){
        const tafHandler = this.tafHandlerList.find(taf => taf.connectType === type);
        if(tafHandler){
            return tafHandler.connected;
        }
        return false;
    }
    
     /*
     * 是否WSLaunch完成
     */
    isWSLaunch(){
        return this.wsLaunch;
    }
    /*
    *更新用户国家码和语言码
    */
    sendWSUpdateUserInfoReq(appSrc){
        this.tafHandler.sendWSUpdateUserInfoReq(appSrc);
    }
    
    /*
    *获取taf基础库
    */
    getTaf(){
        return Taf;
    }
    
    /*
    *获取userId
    */
    getUserId(){
        return  this.tafHandler.userId;
    }

    /*
    *获取Taf协议相关信息 {HUYA,TafMx,Taf}
    */ 
    getTafProtocol(){
        return  {HUYA,TafMx,Taf};
    }
    
    /*
    *二进制解包，返回解包后的数据
    */
    rspDecode(buffer,className){
        return this.tafHandler.rspDecode(buffer,className);
    }

    
    /*
    *tsdb上报接口
    */
    sendDataMetric(list,ua){
        this.tafHandler.sendDataMetric(list,ua);
    }
     
    /*
     * 针对小程序发送二进制数据接口
     * {funcName,buff} 
     */
    sendExtWup(data){
        this.tafHandler.sendExtWup(data);
    }

     /*
     * 云游戏信令建连
     /*[{port,host,ip}]
     */
    connectCloudGameWS(ipList){
        logger.log("云游戏建连",ipList);
        if(this.cloudTaf){
           this.clearCloudTaf();
        }
        let config = {
            ...this.config,
            connectType: 1,
        };
        this.cloudTaf =  new TafHandler(config,this);
        this.cloudTaf.connectIPList(ipList);
        this.tafHandlerList.push(this.cloudTaf);
        return this.cloudTaf;
    }

    
    clearCloudTaf(){
        var idx = this.tafHandlerList.indexOf(this.cloudTaf); 
        if (idx > -1) { 
            this.tafHandlerList.splice(idx, 1); 
        }
        this.cloudTaf.clear();
        this.cloudTaf = null;
    }
    
    /*
     * 云游戏消息发送
     * {data}
     * //需要是结构HUYA.CloudGamePacket
     */
    sendCloudGameReq(data){
        if(!this.cloudTaf){
            logger.log("云游戏连接未创建");
            return;
        }
        this.cloudTaf.sendCloudGameReq(data);
    } 
    /*
     * 获取当前连接的地址
     * type  0普通信令  1云游戏
     */
    getCurrentWSUrl(type=0){
        const tafHan = this.tafHandlerList.find(taf => taf.connectType === type);
        if(tafHan){
            return tafHan.getCurrentWSUrl();
        }
        return "";
    }

    /**
     * performanceInfo 接口成功率上报回调方法
     * @param callback   
     */
    setReportAPI(callback){
        this.tafHandler.setReportAPI(callback);
    }

    /*
     * 更新用户参与的实验，每次更新全量覆盖
     */
    updateUserExps(exps){
        return this.tafHandler.updateUserExps(exps);
    }
}

export default config => new SignalSdk(config);